import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

import { ErrorPlaceholder, withErrorBoundary } from '../general/util/ErrorBoundaries'
import MagazineCarouselRow from './MagazineCarouselRow'
import ThemeLoader from './ThemeLoader'
import DigiMagazineDecadeLoader from './DigiMagazineDecadeLoader'
import DigimagHero from '../navigation/DigimagHero'

import './MagazineArchive.scss'
import magazineStore from '@otavamedia/om-component-library/lib/kea/weeklyMagazine'
import application from '@otavamedia/om-component-library/lib/kea/application'
import { connect } from '../../lib/keaConnect'
import headerStore from '@otavamedia/om-component-library/lib/kea/header'
import { RectShape } from 'react-placeholder/lib/placeholders'
import track from 'react-tracking'
import { pushPageDataToGTM } from '@otavamedia/om-component-library/lib/lib/utils'

const currentMonth = new Date().getMonth() + 1
const currentYear = new Date().getFullYear()
const startYear = 2018

const createYearList = startYear => {
  const years = []
  for (let i = currentYear; i >= startYear; --i) {
    years.push(i)
  }

  // The first issue of a year is published in December of the previous year.
  // If we're in December 2018, we need to show issues for 2019 as well.
  if (years[0] === currentYear && currentMonth === 12) {
    years.unshift(currentYear + 1)
  }

  return years
}

@connect({
  props: [
    magazineStore, [
      'magazine as contents',
    ],
    headerStore, [
      'menus',
    ],
  ],
  actions: [
    application, [
      'setRendered'
    ],
    magazineStore, [
      'loadMagazine'
    ]
  ],
})
class DigiMagazineArchive extends Component {
  constructor (props) {
    super(props)

    const yearsToList = createYearList(startYear)

    this.state = {
      selectedDecade: startYear,
      yearsToList,
      yearsToListLoaded: yearsToList.map(() => false),
      openMagazine: this.props.match ? this.props.match.params.number : null,
      highlightsLoaded: false,
    }
  }

  async componentDidMount () {
    const magazineMenu = this.props.menus.find(menu => menu.taxonomy === 'printmag')
    const magName = magazineMenu.url.match(/\/lehti\/([^/]+)\//)
    this.actions.loadMagazine(magName[0])
    pushPageDataToGTM({})
  }

  openMagazine = (magazine) => {
    if (!magazine.error) {
      this.props.history.push(`/lehti/${magazine.slug}`)
    }
  }

  openThemeMagazine = (magazine) => {
    if (!magazine.error) {
      this.props.history.push(`/teemalehti/${magazine.slug}`)
    }
  }

  UNSAFE_componentWillReceiveProps (newProps) {
    const { yearsToListLoaded } = this.state
    if (!yearsToListLoaded.includes(false) && newProps.contents && newProps.contents.name) {
      this.actions.setRendered(true)
    }
  }

  componentWillUnmount () {
    this.actions.setRendered(false)
  }

  onPagePartLoaded = () => {
    const { yearsToListLoaded } = this.state
    if (!yearsToListLoaded.includes(false) && this.props.contents.name) {
      this.actions.setRendered(true)
    }
  }

  render () {
    const { yearsToList } = this.state
    const { contents } = this.props
    /* eslint-disable jsx-a11y/no-onchange */
    return (
      <Fragment>
        <Helmet>
          <title>
            {`Digilehdet - ${window.om_constants.siteNameGen}`}
          </title>
        </Helmet>
        <div styleName="main-content-col no-h-padding digimag-archive">
          <div styleName="header-row no-border no-h-padding">
            {contents.name
              ? <DigimagHero digimag={contents} toc={true}/>
              : <RectShape style={{ width: '100%', height: 520 }}/>
            }
          </div>
          {
            yearsToList.map((year, idx) => (
              <MagazineCarouselRow
                LoaderComponent={DigiMagazineDecadeLoader}
                title={`${year} digilehdet`}
                onMagazineItemClick={this.openMagazine}
                initialSlide={0}
                highlightSelected={false}
                key={`carousel-${year}`}
                year={year}
                showIcon={false}
                onLoad={() => {
                  const yearsToListLoaded = [...this.state.yearsToListLoaded]
                  yearsToListLoaded[idx] = true
                  this.setState({ yearsToListLoaded }, this.onPagePartLoaded)
                }}
              />
            ))
          }
          <MagazineCarouselRow LoaderComponent={ThemeLoader} title="Teemalehdet"
            onMagazineItemClick={this.openThemeMagazine} initialSlide={0} highlightSelected={false} key={'carousel-theme'}
            showIcon={false}/>
        </div>
      </Fragment>
    )
    /* eslint-enable jsx-a11y/no-onchange */
  }
}

DigiMagazineArchive.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
  contents: PropTypes.object,
  setRendered: PropTypes.func,
  menus: PropTypes.array,
}

export default track({ gtmContext: ['DigiMagazineArchive'] })(withErrorBoundary(
  DigiMagazineArchive,
  ErrorPlaceholder(null)
))
